import { render } from "./MetricsCard.vue?vue&type=template&id=3cda33fb&scoped=true"
import script from "./MetricsCard.vue?vue&type=script&lang=js"
export * from "./MetricsCard.vue?vue&type=script&lang=js"

import "./MetricsCard.vue?vue&type=style&index=0&id=3cda33fb&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cda33fb"]])

export default __exports__